<template>
  <f7-login-screen id="login" @loginscreen:open="open">
    <f7-view>
      <f7-pages>
        <f7-page login-screen>
          <f7-login-screen-title>Login</f7-login-screen-title>
          <f7-list form>
            <f7-list-item>
              <f7-label>Username</f7-label>
              <f7-input
                name="username"
                id="username"
                type="text"
                v-model="loginInfo.username"
                placeholder="Username"
                @keyup.enter="login"
              ></f7-input>
            </f7-list-item>
            <f7-list-item>
              <f7-label>Password</f7-label>
              <f7-input
                name="password"
                id="password"
                type="password"
                v-model="loginInfo.password"
                placeholder="Password"
                @keyup.enter="login"
              ></f7-input>
            </f7-list-item>
          </f7-list>
          <f7-list>
            <f7-list-button @click="login" title="Login"></f7-list-button>
            <!-- <f7-list-label>
              <f7-link @click="cancel">Cancel</f7-link>
            </f7-list-label> -->
          </f7-list>
        </f7-page>
      </f7-pages>
    </f7-view>
  </f7-login-screen>
</template>

<script>
import Settings from '../settings'

const maiurl = 'http://' + Settings.host + ':5151'

export default {
  data () {
    return {
      loginInfo: {username: '', password: ''}
    }
  },
  methods: {
    open: function () {
      console.log('open..')
      var vm = this
      vm.resetForm({alsoStorage: true})
      if (Settings.mAutoLogin) { vm.loginInfo = process.env.mLoginInfo; vm.login() }
    },
    resetForm: function (opt) {
      var vm = this
      opt = opt || {}
      vm.loginInfo.username = ''
      vm.loginInfo.password = ''
      if (opt.alsoStorage) localStorage.removeItem('user')
    },
    login: function () {
      var vm = this

      console.log('trying to login...')
      document.getElementById('username').blur()
      document.getElementById('password').blur()
      // var authdetail = window.btoa(vm.loginInfo.username + ':' + vm.loginInfo.password)
      var authdetail = btoa(
        unescape(
          encodeURIComponent(
            vm.loginInfo.username + ':' + vm.loginInfo.password
          )
        )
      ) // utf support: https://stackoverflow.com/a/26603875/263948
      vm.$http
        .get(maiurl + '/check_credentials', {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(
          response => {
            console.log('login success', response.body)
            var user = { auth: authdetail, scope: response.body, username: vm.loginInfo.username }
            localStorage.setItem('user', JSON.stringify(user))
            vm.resetForm()
            vm.$emit('success')
            vm.$f7.closeModal('#login')
          },
          response => {
            console.log('login fail')
            vm.resetForm()
            if (response.status === 401) {
              vm.$f7.alert('You are unauthorized to view this page', 'Login Failed')
            } else {
              vm.$f7.alert('Possibly connection error<br />(Status code #' + response.status + ')', 'Login Failed')
            }
            console.dir(response)
            console.dir(response.status)
          }
        )
    },
    cancel: function (event) {
      console.log('login cancel')
      var vm = this
      vm.resetForm({alsoStorage: true})
      vm.$f7.closeModal('#login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue